<template>
  <div class="content">
  <div class="lald-case__block">
    <div class="lald-case__block-head">
      <div class="lald-case__block-head-title">Анамнез</div>
    </div>
    <div class="lald-case__block-body">
      <div class="lald-case__block-body-row">
        <div class="lald-case__block-body-img">
          <img
            :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy.png 2x`"
          />
        </div>
        <div class="lald-case__block-body-content">
          <div class="lald-case__block-body-name">Денис</div>
          <div class="lald-case__block-body-age mb-6">5 лет</div>
          <div class="lald-case__block-body-text">
            <p class="mb-4 default-text">
              Мама обратилась с жалобами на быструю утомляемость и частые боли в
              животе. В 3 года было впервые выявлено повышение холестерина.
            </p>
            <hr />
            <p class="default-text mt-4">
              Родители пациента здоровы, брак не близкородственный. Ребенок от
              1й беременности, протекавшей с угрозой прерывания в первом
              триместре.
              <br />Масса ребенка при рождении 3115 г, длина 54 см. Неонатальный
              период протекал без особенностей. На грудном вскармливании
              находился до 7 мес., прикормы ввелись в 5 мес.
            </p>
          </div>
          <div class="lald-case__block-button button button_orange-gradient mt-4" @click="$emit('toStep', 1)">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.1243 7.49926C13.1243 8.23795 12.9788 8.9694 12.6961 9.65186C12.4134 10.3343 11.9991 10.9544 11.4767 11.4767C10.9544 11.9991 10.3343 12.4134 9.65186 12.6961C8.9694 12.9788 8.23795 13.1243 7.49926 13.1243C6.76058 13.1243 6.02912 12.9788 5.34667 12.6961C4.66421 12.4134 4.04412 11.9991 3.52179 11.4767C2.99946 10.9544 2.58512 10.3343 2.30244 9.65186C2.01976 8.9694 1.87426 8.23795 1.87426 7.49926C1.87426 6.00742 2.46689 4.57668 3.52179 3.52179C4.57668 2.46689 6.00742 1.87426 7.49926 1.87426C8.9911 1.87426 10.4218 2.46689 11.4767 3.52179C12.5316 4.57668 13.1243 6.00742 13.1243 7.49926ZM12.0993 13.4243C10.5922 14.5942 8.69597 15.1459 6.79651 14.9669C4.89705 14.788 3.13719 13.8919 1.8752 12.461C0.613204 11.0302 -0.0560502 9.17213 0.00367996 7.2652C0.0634101 5.35826 0.847635 3.54577 2.1967 2.1967C3.54577 0.847635 5.35826 0.0634101 7.2652 0.00367996C9.17213 -0.0560502 11.0302 0.613204 12.461 1.8752C13.8919 3.13719 14.788 4.89705 14.9669 6.79651C15.1459 8.69597 14.5942 10.5922 13.4243 12.0993L16.9118 15.5868C17.0039 15.6726 17.0777 15.7761 17.129 15.8911C17.1802 16.0061 17.2078 16.1302 17.21 16.2561C17.2122 16.382 17.1891 16.507 17.1419 16.6238C17.0948 16.7405 17.0246 16.8465 16.9356 16.9356C16.8465 17.0246 16.7405 17.0948 16.6238 17.1419C16.507 17.1891 16.382 17.2122 16.2561 17.21C16.1302 17.2078 16.0061 17.1802 15.8911 17.129C15.7761 17.0777 15.6726 17.0039 15.5868 16.9118L12.0993 13.4243Z"
                fill="white"
              />
            </svg>
            Провести осмотр
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "Step1",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/laldICC.scss";

.lald-case {
  &__block {
    &-body {
      &-row {
        display: grid;
        grid-template-columns: 390px 1fr;
        gap: 40px;

         @media screen and (max-width: 1219px) {
          grid-template-columns:  1fr;
        }

        @media screen and (max-width: 767px) {
          grid-template-columns:  1fr;
        }
      }
      &-name {
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 29px;
        color: #5c539e;
      }

      &-age {
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 22px;
        line-height: 26px;
        color: #1f1f1f;
      }
    }
  }
}
</style>